import { UtmParams } from '@porterin/component-library/src/ts-utils/analytics/react-ga/types/GaTrackingPayload';

export const getUtmParams = (): UtmParams => {
  const urlParams = new URLSearchParams(window?.location?.search);
  return {
    campaign_id: urlParams.get('utm_id') ?? '',
    campaign: urlParams.get('utm_campaign') ?? '',
    source: urlParams.get('utm_source') ?? '',
    medium: urlParams.get('utm_medium') ?? '',
    term: urlParams.get('utm_term') ?? '',
    content: urlParams.get('utm_content') ?? '',
  };
};
